export default "__VITE_ASSET__633011aa__"